import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '@/utils/cn';

const RadixTooltip = TooltipPrimitive.Root;

const RadixTooltipTrigger = TooltipPrimitive.Trigger;

const RadixTooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, children, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-tooltip-content-transform-origin)',
        className
      )}
      {...props}
    >
      {children}
      	<TooltipPrimitive.Arrow width={12} height={6} className="fill-[#E4F8FF]" />
    </TooltipPrimitive.Content>
  </TooltipPrimitive.Portal>
));

RadixTooltipContent.displayName = TooltipPrimitive.Content.displayName;

const RadixTooltipProvider = ({ children }: { children: React.ReactNode }) => {
  return <TooltipPrimitive.Provider delayDuration={0}>{children}</TooltipPrimitive.Provider>;
};

type AppTooltipProps = Omit<
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>,
  'children' | 'content'
> & {
  children: React.ReactNode;
  content: React.ReactNode;
};

const AppTooltip = ({ children, content, className, ...props }: AppTooltipProps) => {
  return (
    <RadixTooltip>
      <RadixTooltipTrigger asChild>{children}</RadixTooltipTrigger>
      <RadixTooltipContent
        className={cn('bg-white text-[#25151E] text-[12px] font-normal p-2 rounded-lg border', className)}
        {...props}
      >
        {content}
      </RadixTooltipContent>
    </RadixTooltip>
  );
};

export { RadixTooltip, RadixTooltipTrigger, RadixTooltipContent, RadixTooltipProvider, AppTooltip };
